import TooltipPro from 'epn-ui/umd/dist/components/TooltipPro';
import useI18n from '@i18n';
import Card from './Card';

export interface IInfoCardsProps {
    confirm: number;
    cr: number;
    confirmDays: number;
    cookieLive: string;
    maxRate: number;
    maxRateSymbol: string;
}

const InfoCards: React.FC<IInfoCardsProps> = ({
    confirm,
    cr,
    confirmDays,
    cookieLive,
    maxRate,
    maxRateSymbol,
}) => {
    const { t } = useI18n('Offers');
    const { t: tCommon } = useI18n('Common');

    return (
        <div className="flex mb-4 overflow-x-auto xs:mb-2 lg:overflow-x-hidden hide-scrollbar sm:grid sm:grid-cols-3 gap-1 sm:gap-2 lg:gap-3 md:flex mx-[-8px] sm:mx-[0] lg:max-w-[823px] xl:max-w-[1048px]">
            <Card
                className="flex-shrink-0 sm:col-span-1 min-w-[100px] md:min-w-[130px] ml-[8px] sm:ml-[0]"
                title={tCommon('Rate')}
                value={`${t('To')} ${maxRate || ''}${maxRateSymbol || ''}`}
            />
            <Card
                className="flex-shrink-0 sm:col-span-1 min-w-[155px] md:min-w-[180px]"
                title={t('% confirmation')}
                value={`${confirm}%`}
            />
            <Card
                className="flex-shrink-0 sm:col-span-1 min-w-[105px] md:min-w-[160px] lg:min-w-[140px] xl:min-w-[180px]"
                title={t('Conversion')}
                value={`${cr}%`}
            />
            <Card
                className="flex-shrink-0 sm:col-span-1 min-w-[118px] md:min-w-[160px] lg:min-w-[140px] xl:min-w-[160px] xs:min-w-[160px]"
                title={t('Payment term')}
                value={t('Up to days', { count: confirmDays })}
            />
            <div className="hidden lg:block">
                <TooltipPro title={cookieLive} placement="right">
                    <div>
                        <Card
                            className="flex-shrink-0 sm:col-span-2 min-w-[200px] lg:max-w-[184px] lg:min-w-[184px] xl:min-w-[350px] xl:max-w-[350px] mr-[8px] sm:mr-[0]"
                            title={t('Lifetime of cookie')}
                            value={cookieLive}
                        />
                    </div>
                </TooltipPro>
            </div>
            <Card
                className="flex-shrink-0 sm:col-span-2 min-w-[200px] mr-[8px] sm:mr-[0] lg:hidden"
                title={t('Lifetime of cookie')}
                value={cookieLive}
            />
        </div>
    );
};

export default InfoCards;
